import axios from "axios";
import qs from "qs";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { Message } from "element-ui";

//创建axios实例
const service = axios.create({
  baseURL: "/api",
  timeout: 50000,
  withCredentials: true,
  paramsSerializer: function(params) {
    return qs.stringify(params, {
      arrayFormat: "brackets",
    });
  },
});

// request发起请求前，拦截器
service.interceptors.request.use(
  (config) => {
    NProgress.start();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 根据后台传过来的数据进行响应拦截
service.interceptors.response.use(
  (response) => {
    NProgress.done();
    let res = { data: response.data, status: response.status };
    return res;
  },

  (error) => {
    NProgress.done();
    let code = error.message.replace(/[^0-9]/gi, "");

    if (code == 401) {
      Message({
        message: "用户名或密码不正确",
        type: "error",
        duration: 5 * 1000,
      });
    } else {
      Message({
        message: error.message,
        type: "error",
        duration: 5 * 1000,
      });
    }

    return Promise.reject(error);
  }
);

export default service;
